import { apiRequest, buildURL } from './commons/CommonService.Functions';

// models
import {
  IdentifierTypeCreateCommand,
  IdentifierTypeUpdateCommand,
  IdentifierTypeViewModel
} from '../models/Entities/Person/IdentifierType/IdentifierTypeModels';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'persons/identifiertypes';

// Get all identifier types
export const GetIdentifierTypes = async (
  token: string,
  includeDeleted: boolean = false
): Promise<IdentifierTypeViewModel[]> => {
  const requestUrl: string = `${BaseURL}?IncludeDeleted=${includeDeleted}`;
  return apiRequest<IdentifierTypeViewModel[]>(requestUrl, token, 'GetIdentifierTypes');
};

// Get identifier type by id
export const GetIdentifierTypeById = async (
  token: string,
  identifierTypeId: number
): Promise<IdentifierTypeViewModel> => {
  const requestUrl: string = buildURL(BaseURL, identifierTypeId);
  return apiRequest<IdentifierTypeViewModel>(requestUrl, token, 'GetIdentifierTypeById');
};

// Create identifier type
export const CreateIdentifierType = async (
  token: string,
  payload: IdentifierTypeCreateCommand
): Promise<IdentifierTypeViewModel> => {
  return apiRequest<IdentifierTypeViewModel>(BaseURL, token, 'CreateIdentifierType', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

// Update identifier type
export const UpdateIdentifierType = async (
  token: string,
  payload: IdentifierTypeUpdateCommand
): Promise<IdentifierTypeViewModel> => {
  return apiRequest<IdentifierTypeViewModel>(BaseURL, token, 'UpdateIdentifierType', {
    method: 'PUT',
    body: JSON.stringify(payload)
  });
};

// Delete identifier type
export const DeleteIdentifierType = async (
  token: string,
  identifierTypeId: number
): Promise<number> => {
  const requestUrl: string = buildURL(BaseURL, identifierTypeId);
  return apiRequest<number>(requestUrl, token, 'DeleteIdentifierType', {
    method: 'DELETE'
  });
};
